import { WSAvatar, WSElement, WSText } from "@wingspanhq/fe-component-library";
import React from "react";

type Props = {
  name: string;
  email?: string;
};

// Presentational only — payee identity block, driven purely by props so a
// future guest-flow sibling can feed it a differently-sourced
// ClientPayableView.
export const ClientPayablePayeeInfo: React.FC<Props> = props => (
  <WSElement>
    <WSAvatar
      type="text"
      text={props.name}
      color="white"
      colorBackground="gray500"
      mb="S"
    />
    <WSText.Heading5>{props.name}</WSText.Heading5>
    {props.email && <WSText color="gray500">{props.email}</WSText>}
  </WSElement>
);
